'use strict';

const POLL_FREQUENCY = 1000 * 10, // ten seconds
  ContentUtils = require('utils/ContentUtils'),
  {t} = require('services/i18nextWrapper'),
  RestUtils = require('utils/RestUtils'),
  Security = require('services/Security').auth,
  SessionStore = require('stores/SessionStore'),
  DashboardStore = require('stores/DashboardStore'),
  {MAX_DRAFT_OPERATION} = require('constants/AppConstants'),
  DashboardSpinnerEl = require('views/Dashboard/DashboardSpinnerHolder'),
  Notification = require('components/Notification/Notification'),
  DashboardAction = require('../actions/DashboardActionCreators'),
  DashboardServiceCache = require('services/DashboardServiceCache');


/**
 * The simple pulling class that auto save in pulling way the current draft if was changed.
 * @type {{inProgress: boolean, intervalId: null, poll: Function, start: Function, stop: Function}}
 */
const PollerDraft = {
  
  /**
   * The flag that allow as to not pull other request after finish the previous one.
   */
  inProgress: false,
  
  /**
   * The native interval id that allow as to stop the cycle when we need it.
   */
  intervalId: null,
  
  /**
   * Auto save draft in backend side in pulling way.
   */
  poll(callback) {
    if (this._shouldPoll()) {
      const self = this;
      try {
        
        this.inProgress = true;
        const ajax = RestUtils.createXHR();
        const path = process.env.URL_API + '/orders/' + SessionStore.getCurrentApplicant() + '/draft';
        const currentPendingOperations = DashboardServiceCache.getPendingOperations();
  
        ajax.addEventListener('error', function (error) {
          if (!error) {
            error = {};
          }
          if (!error.type) {
            error.type = '';
          }
          
          console.error('PollerSaveDraft Error: ' + this.responseText + ' type: ' + error.type + ' loaded: ' + error.loaded);
          self.inProgress = false;
          if (callback) {
            callback();
          }
        });
        
        DashboardSpinnerEl.show();
        
        ajax.addEventListener('load', function () {
          RestUtils.handlerResponse(this, function () {
            const {lastIndexSaved} = ContentUtils.parse(this.responseText);
            Notification.show(t('dashboard_notification_draft_auto_saved'), 'success');
            DashboardServiceCache.markAsSavedOperationsUntilIndex(currentPendingOperations, lastIndexSaved);
            DashboardAction.savingDraftSuccess();
            DashboardSpinnerEl.hide();
            self.inProgress = false;
            
            if (callback) {
              callback(lastIndexSaved);
            }
          }, function () {
            // retry again
            self.inProgress = false;
          });
        });
        
        ajax.open('POST', path);
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader('X-AUTH-TOKEN', Security.getToken());
        
        ajax.send(JSON.stringify({
          'operations': currentPendingOperations
        }));
        
      } catch (err) {
        self.inProgress = false;
        console.error(err);
        DashboardAction.savingDraftFailure();
      }
    }
    
    this._cleanSavedOperations();
  },
  
  /**
   * Valid if need to poll pending operations
   * @returns {boolean}
   * @private
   */
  _shouldPoll() {
  
    if (this.inProgress === true) {
      return false;
    }
    if (DashboardServiceCache.getPendingOperations().filter(operation => !operation.isSaved).length > 0) {
      return true;
    }
    return false;
  },
  
  /**
   * Clean non saved draft operations in order to improve memory consumption.
   * @private
   */
  _cleanSavedOperations() {
    const hasPendingOperationToSave = DashboardServiceCache.getPendingOperations().length > 0;
    const maxOperationAllowed = DashboardServiceCache.getOperations().length >= MAX_DRAFT_OPERATION;
    const hasOperations = DashboardServiceCache.getOperations().length > 0;
    if (SessionStore.isAdminUser() &&
      hasOperations &&
      maxOperationAllowed
    ) {
      DashboardServiceCache.cleanSavedOperations();
    } else if (
      SessionStore.isAdminUser() &&
      hasOperations &&
      !hasPendingOperationToSave &&
      !DashboardStore.isPublishingDraft() &&
      !DashboardStore.isSavingDraft() &&
      !DashboardStore.isDraggingOrResizing()
    ) {
      DashboardServiceCache.cleanSavedOperations();
    }
  },
  
  /**
   * Start pulling in order to auto save given draft.
   */
  start() {
    if (SessionStore.isAdminUser()) {
      this.refreshIntervalId = setInterval(this.poll.bind(this), POLL_FREQUENCY);
    }
  },
  
  /**
   * Stop current pulling
   */
  stop() {
    clearInterval(this.refreshIntervalId);
  }
  
};

module.exports = PollerDraft;



/** WEBPACK FOOTER **
 ** ./src/pollers/PollerSaveDraft.js
 **/